module.exports = __webpack_public_path__ + "img/Qd.7952a94e.png";